/**
 * Utilitná funkcia pre konverziu objektu na string vo forme query parametrov url
 * @param {object} - Objekt pre konverziu
 * @returns {string} - Objekt preložený na string
 * @example
 * ```javascript
 * import objectToParams from 'utilities/lib/objectToParams';
 *
 * const object = {
 *   property: 'PropertyValue',
 *   anotherProperty: 'AnotherPropertyValue',
 * };
 *
 * console.log(objectToParams(object)); // property=PropertyValue&anotherProperty=AnotherPropertyValue
 * ```
 */
export default function objectToParams(obj) {
    if (!obj) {
        return '';
    }
    var str = [];
    Object.keys(obj).forEach(function (p) {
        if (typeof obj[p] !== 'undefined' && obj[p] !== null) {
            str.push(encodeURIComponent(p) + "=" + encodeURIComponent(String(obj[p])));
        }
    });
    return str.join('&');
}
